module.exports = __webpack_public_path__ + "static/media/5ed7b0fd72f4e5e57a748792.64cdeaf1.png";